import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, CircleNotch, EnvelopeSimple } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { setErr(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <Link to="/" className="flex items-center mb-8 justify-center">
          <Logo className="h-9" />
        </Link>
        {sent ? (
          <div className="text-center bg-white border border-border rounded-lg p-8" data-testid="forgot-sent">
            <EnvelopeSimple size={40} className="text-primary mx-auto mb-4" />
            <h1 className="font-display text-2xl font-800 tracking-tight mb-2">Revisa tu correo</h1>
            <p className="text-sm text-muted-foreground">
              Si el correo existe, enviamos instrucciones para restablecer tu contraseña.
            </p>
            <Link to="/login"><Button variant="outline" className="mt-6 w-full">Volver a ingresar</Button></Link>
          </div>
        ) : (
          <>
            <h1 className="font-display text-3xl font-800 tracking-tight mb-2">¿Olvidaste tu contraseña?</h1>
            <p className="text-sm text-muted-foreground mb-6">Ingresa tu correo y te enviaremos un enlace de recuperación.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="email">Correo electrónico</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                  data-testid="forgot-email" className="mt-1.5" />
              </div>
              {err && <p className="text-sm text-destructive">{err}</p>}
              <Button type="submit" disabled={loading} data-testid="forgot-submit"
                className="w-full bg-primary hover:bg-blue-600 text-white">
                {loading ? <CircleNotch className="animate-spin" /> : "Enviar enlace"}
              </Button>
            </form>
            <p className="text-sm text-muted-foreground mt-6 text-center">
              <Link to="/login" className="text-primary hover:underline">Volver a ingresar</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
